import { useOutletContext } from 'react-router-dom'

import { LOCAL_STORAGE_KEYS } from 'config/Vars'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import useLocalStorage from 'modules/core/lib/useLocalStorage'

import type { RouteContextParams } from 'modules/expenses/lib/RouteContextParams'

type UseShowCardsBanner = (props: Props) => {
  showCardsBanner: boolean
  onDismiss: () => void
}

interface Props {
  canManageCards: boolean
}

const useShowCardsBanner: UseShowCardsBanner = ({ canManageCards }: Props) => {
  const { loading, accountProvidersAvailable, onboarding } = useOutletContext<RouteContextParams>()
  const [hasDismissedExpensesListCardsBanner, setHasDismissedExpensesListCardsBanner] =
    useLocalStorage<boolean>(LOCAL_STORAGE_KEYS.expensesHasDismissedExpensesListCardsBanner)

  const isLoaded = loading === false
  const onboardingNotReady = [
    !onboarding,
    onboarding?.status == 'missing_information',
    onboarding?.status == 'pending',
  ].some(Boolean)

  const showCardsBanner = [
    accountProvidersAvailable,
    isLoaded,
    onboardingNotReady,
    !hasDismissedExpensesListCardsBanner,
    canManageCards,
  ].every(Boolean)

  const onDismiss = () => {
    track(trackingEvents.expenses.skipCardsBanner)
    setHasDismissedExpensesListCardsBanner(true)
  }

  return { showCardsBanner, onDismiss }
}

export default useShowCardsBanner
